export const CreateItemCheckBoxTypes = {
  OWN: 'Vertia',
  SUBCONTRACTOR: 'Alihankkija',
}
